import EndPoint from 'Api/EndPoint';
import Client from 'Api/Client';

const endpoint = `${EndPoint.HostV2}/${EndPoint.ShoppingCart}`;

export async function getShoppingCartList(fieldId) {
  return await Client.get(`${endpoint}/${fieldId}`, {}, true);
}

export async function putShoppingCart(fieldId, data) {
  return await Client.put(`${endpoint}/${fieldId}`, data, true);
}

export async function deleteShoppingCart(fieldId, data) {
  return await Client.delete(`${endpoint}/${fieldId}`, data, true);
}
